import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UserAccountType } from 'src/app/data-types/user-data';
import { ESmartDateSelectionRangeType } from '../../../shared/smart-date-selection/smart-date-selection.enum';
import { SmartDateSelectionComponent } from 'src/app/shared/smart-date-selection/smart-date-selection.component';
import { Store } from 'src/app/store';

export interface ILeadListFiltersOutput {
    customerType: UserAccountType;
    leadType: 0 | 1;
    admin: string;
    startDate: string;
    endDate: string;
}

export const LeadListFiltersDefutlts: ILeadListFiltersOutput = {
    customerType: null,
    leadType: null,
    admin: null,
    startDate: null,
    endDate: null,
};

@Component({
    selector: 'app-lead-list-filters',
    templateUrl: './lead-list-filters.component.html',
    styleUrls: ['./lead-list-filters.component.scss'],
})
export class LeadListFiltersComponent implements OnInit {
    @Input() admins = [];
    @Output() filtersChanged = new EventEmitter<ILeadListFiltersOutput>();
    @ViewChild(SmartDateSelectionComponent)
    smartDateSelector: SmartDateSelectionComponent;

    ESmartDateSelectionRangeType = ESmartDateSelectionRangeType;

    selectedCustomerType: UserAccountType = null;
    selectedLeadType = null;
    selectedAdmin: string;
    startDate: string;
    endDate: string;

    customerTypes = [
        { id: UserAccountType.Guest, name: 'Unknown' },
        { id: UserAccountType.Customer, name: 'Private' },
        { id: UserAccountType.Trade, name: 'Trade', email: '' },
    ];
    leadTypes = [
        { value: 1, name: 'Warm' },
        { value: 0, name: 'Cold' },
    ];

    constructor(private fb: FormBuilder, private store: Store) {}

    ngOnInit(): void {
        this.getStateFromStore();
    }

    ngAfterViewInit(): void {
        if (this.endDate && this.startDate) {
            this.smartDateSelector.setDates(this.startDate, this.endDate);
        }
    }

    applyFilters() {
        const filtersState: ILeadListFiltersOutput = {
            customerType: this.selectedCustomerType,
            leadType: this.selectedLeadType,
            admin: this.selectedAdmin,
            startDate: this.startDate,
            endDate: this.endDate,
        };
        this.saveStateIntoStore();
        this.filtersChanged.emit(filtersState);
    }

    resetFilters() {
        this.selectedCustomerType = null;
        this.selectedLeadType = null;
        this.selectedAdmin = null;
        this.startDate = null;
        this.endDate = null;
        this.smartDateSelector.reset$.next();

        this.saveStateIntoStore();
        this.applyFilters();
    }

    dateRangeChanged(dateRange) {
        this.startDate = dateRange.startDate;
        this.endDate = dateRange.endDate;
    }

    private getStateFromStore() {
        const leadsFilters = this.store.selectForLocal('leadsFilters');
        this.selectedCustomerType = leadsFilters.filters.customerType;
        this.selectedLeadType = leadsFilters.filters.leadType;
        this.selectedAdmin = leadsFilters.filters.admin;
        this.startDate = leadsFilters.filters.startDate;
        this.endDate = leadsFilters.filters.endDate;
        this.applyFilters();
    }

    private saveStateIntoStore() {
        const leadsFilters = this.store.selectForLocal('leadsFilters');
        leadsFilters.filters = {
            customerType: this.selectedCustomerType,
            leadType: this.selectedLeadType,
            admin: this.selectedAdmin,
            startDate: this.startDate,
            endDate: this.endDate,
        };
        this.store.set('leadsFilters', leadsFilters);
    }
}
